export const BG_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/bg.webp'
/** Background for alliance dashboard (after join/create) — redesign cinematic bg */
export const MANAGE_BG_URL =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/alliance/alliance-page-bg.webp'
/** Background for alliance manage page title banner */
export const MANAGE_TITLE_BANNER_BG_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/manage/title-banner-bg.webp'
/** Background for alliance manage tab buttons */
export const TAB_BTN_BG_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/manage/tab-btn-bg.webp'
/** Frame overlay for alliance avatars */
export const AVATAR_FRAME_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/manage/avatar-frame.webp'
export const TITLE_BANNER_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/title-banner.webp'
export const PANEL_BG_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/panel-bg.webp'
export const HERO_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/hero.webp'
export const DEFAULT_AVATAR = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/NFT/default.webp'

/** Gold metallic title gradient (Overview panel titles + Tasks headings). */
const ALLIANCE_PANEL_GOLD_TITLE =
  'font-alliance-panel font-normal uppercase ' +
  'bg-gradient-to-b from-[#F5D98A] via-[#E3B95C] to-[#8A5B12] bg-clip-text text-transparent ' +
  '[-webkit-background-clip:text] [-webkit-text-fill-color:transparent] [background-clip:text] ' +
  '[filter:drop-shadow(0_1px_0_rgba(0,0,0,0.78))_drop-shadow(0_0_6px_rgba(227,185,92,0.28))]'

/** Paragraph core shared by Overview announcement + Diplomacy/Messages body copy (size, weight, color). */
export const ALLIANCE_MANAGE_BODY_CORE =
  'text-xs font-normal leading-relaxed text-[#3A1C0B] sm:text-sm [font-family:Cormorant_Garamond,EB_Garamond,Georgia,serif] [text-shadow:0_1px_2px_rgba(0,0,0,0.12)]'

/**
 * Readable warm brown / parchment text for alliance Manage → Overview (and embedded resources tile).
 * Alliance info hero: Cinzel authority title, Baskerville/Garamond motto, small-caps labels, Merriweather stats, etched dividers.
 */
export const ALLIANCE_OVERVIEW_TEXT = {
  /** Panel titles — gold metallic (Roman display: Marcellus + Cinzel). */
  sectionTitle:
    ALLIANCE_PANEL_GOLD_TITLE + ' text-center text-xs tracking-[0.18em] sm:text-sm',
  /** Alliance name — bold Cinzel / Trajan-like, dark bronze gradient, subtle emboss (guild authority). */
  heroTitle:
    'text-lg font-bold tracking-[-0.015em] antialiased sm:text-2xl ' +
    '[font-family:Cinzel,Georgia,serif] ' +
    'bg-clip-text text-transparent [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] [background-clip:text] ' +
    'bg-[linear-gradient(180deg,#4A2816_0%,#3B1F0D_42%,#2B1608_100%)] ' +
    '[filter:drop-shadow(0_-0.5px_0_rgba(255,224,190,0.11))_drop-shadow(0_1px_0_rgba(0,0,0,0.45))_drop-shadow(0_1px_2px_rgba(0,0,0,0.26))] ' +
    '[font-feature-settings:"kern"_1,"liga"_1]',
  /** Announcement / default motto — literary italic serif, antique ink browns, light emboss. */
  motto:
    'mt-1.5 text-[0.72rem] font-normal italic leading-relaxed antialiased [text-rendering:optimizeLegibility] sm:text-[0.82rem] ' +
    '[font-family:Libre_Baskerville,Cormorant_Garamond,Georgia,serif] ' +
    'bg-clip-text text-transparent [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] [background-clip:text] ' +
    'bg-[linear-gradient(180deg,#5A3E1C_0%,#5A3315_45%,#4A2A12_100%)] ' +
    '[filter:drop-shadow(0_-0.5px_0_rgba(255,248,232,0.07))_drop-shadow(0_0.5px_1px_rgba(0,0,0,0.2))]',
  /** LEADER: / MEMBERS: / GOVERNANCE — small-caps Cinzel, deep brown, engraved label. */
  statLabel:
    'text-[0.68rem] font-semibold tracking-[0.045em] text-[#3C220F] sm:text-[0.72rem] ' +
    '[font-family:Cinzel,Georgia,serif] [font-variant-caps:small-caps] [font-feature-settings:"smcp"_1,"kern"_1] ' +
    '[text-shadow:0_-0.5px_0_rgba(255,235,210,0.09),0_1px_0_rgba(0,0,0,0.26),0_1px_1px_rgba(0,0,0,0.14)] antialiased',
  /** Stat values — Merriweather bold + dark bronze, RPG panel emphasis. */
  statValue:
    'min-w-0 truncate text-right text-[0.72rem] font-bold tabular-nums text-[#2F190A] antialiased sm:text-[0.78rem] ' +
    '[font-family:Merriweather,Cinzel,Georgia,serif] ' +
    '[text-shadow:0_-0.5px_0_rgba(255,248,238,0.05),0_1px_0_rgba(0,0,0,0.32),0_1px_2px_rgba(0,0,0,0.16),0_0_6px_rgba(47,25,10,0.05)]',
  statAccent: 'text-[#2F190A]',
  statMuted:
    'ml-1 tabular-nums text-[0.65rem] font-medium italic text-[#5A3315] sm:text-[0.7rem] [font-family:Libre_Baskerville,Cormorant_Garamond,serif]',
  /** Etched parchment dividers between stat rows (#6A4A28, soft). */
  ul: 'mt-3 w-full divide-y divide-[rgba(106,74,40,0.34)] text-[0.72rem] sm:text-xs [&>li]:py-2 [&>li:first-child]:pt-1',
  /** Announcement / task banners */
  bannerBox:
    'mb-1 rounded border border-[rgba(90,51,21,0.45)] bg-[rgba(28,22,16,0.45)] p-2 text-left text-[0.68rem] leading-snug text-[#3A1C0B] sm:text-[0.72rem] [font-family:Cormorant_Garamond,Georgia,serif]',
  bannerHeading:
    'font-alliance-panel font-semibold uppercase tracking-[0.08em] text-[#4A2A10] [text-shadow:0_1px_1px_rgba(0,0,0,0.2)]',
  bannerMuted: 'mt-1 font-normal text-[#3A1C0B]',
  bannerDates: 'mt-1 tabular-nums font-normal text-[#4A3318]',
  bannerHint: 'mt-0.5 text-[0.62rem] text-[#5a4030]',
  announcementBody: 'min-h-0 flex-1 whitespace-pre-wrap text-left ' + ALLIANCE_MANAGE_BODY_CORE,
  signedLine: 'mt-1 shrink-0 text-[0.65rem] font-normal text-[#5a4030] sm:text-xs [font-family:Cormorant_Garamond,Georgia,serif]',
  emptyState:
    'max-w-[16rem] text-center text-[0.72rem] font-normal italic leading-relaxed text-[#5a4030] sm:max-w-none sm:text-xs [font-family:Cormorant_Garamond,Georgia,serif]',
  officialTag:
    'font-alliance-panel text-xs font-semibold uppercase tracking-[0.1em] text-[#5A3315]',
  officialTitle:
    'mt-1 whitespace-pre-wrap text-left text-[0.78rem] font-bold leading-relaxed text-[#2B160A] sm:text-sm [font-family:Merriweather,Georgia,serif] [text-shadow:0_1px_1px_rgba(255,252,245,0.1),0_1px_2px_rgba(0,0,0,0.2)]',
  governanceIntro:
    'font-alliance-panel max-w-[14rem] text-center text-[0.74rem] font-semibold uppercase tracking-[0.06em] text-[#4A2A10] sm:max-w-none sm:text-sm [text-shadow:0_1px_2px_rgba(0,0,0,0.2)]',
  governanceSub:
    'max-w-[15rem] text-center text-[0.64rem] font-normal leading-snug text-[#5a4030] sm:max-w-none sm:text-xs [font-family:Cormorant_Garamond,Georgia,serif] [text-shadow:0_1px_1px_rgba(0,0,0,0.15)]',
  badgeScore:
    'font-alliance-panel -translate-y-[5px] text-2xl font-bold tabular-nums text-[#F0C868] sm:text-3xl ' +
    '[text-shadow:0_0_16px_rgba(240,200,104,0.7),0_0_28px_rgba(180,120,40,0.35),0_2px_4px_rgba(0,0,0,0.55),0_1px_0_rgba(255,255,255,0.35)]',
  governanceScoreInline:
    'shrink-0 text-[0.72rem] font-bold tabular-nums text-[#2F190A] antialiased sm:text-[0.78rem] [font-family:Merriweather,Cinzel,Georgia,serif] [text-shadow:0_-0.5px_0_rgba(255,248,238,0.05),0_1px_0_rgba(0,0,0,0.3),0_1px_2px_rgba(0,0,0,0.15)]',
  /** Members table */
  tableHead:
    'font-alliance-panel border-b border-[rgba(90,51,21,0.4)] text-[0.6rem] font-semibold uppercase tracking-[0.12em] text-[#5A3315] sm:text-[0.65rem] [text-shadow:0_1px_0_rgba(255,255,255,0.05),0_1px_2px_rgba(0,0,0,0.28)]',
  tableRow: 'border-b border-[rgba(90,62,40,0.3)] text-[#2B160A] [font-family:Merriweather,Georgia,serif]',
  tableRowSelf: ' bg-[rgba(120,90,52,0.12)]',
  tableRankNum: 'tabular-nums text-[#5A3315] font-semibold [font-family:Cinzel,Georgia,serif]',
  memberNick: 'font-bold text-[#2B160A] [text-shadow:0_1px_0_rgba(255,252,245,0.08),0_1px_2px_rgba(0,0,0,0.18)]',
  memberLeaderNote: 'ml-1 font-semibold text-[#5A3315] [font-family:Cinzel,Georgia,serif]',
  tableMutedCell: 'text-[#4A3318]',
  lastOnlineCell:
    'whitespace-nowrap text-[0.62rem] text-[#3A1C0B] sm:text-[0.65rem] [text-shadow:0_1px_1px_rgba(0,0,0,0.12)]',
  onlineStatus:
    'inline-flex items-center gap-1.5 text-[0.62rem] font-semibold text-[#4F7F3D] sm:text-[0.65rem] [text-shadow:0_0_8px_rgba(79,127,61,0.35),0_1px_1px_rgba(0,0,0,0.2)]',
  offlineStatus: 'inline-flex items-center gap-1.5 font-normal text-[#6b5c50] [text-shadow:0_1px_2px_rgba(0,0,0,0.15)]',
  /** Resources tile (transparent shell) — name matches amount weight/color. */
  resourceLabel:
    'text-[0.95rem] font-bold text-[#2B160A] [font-family:Merriweather,Georgia,serif] [text-shadow:0_1px_0_rgba(255,252,245,0.1),0_1px_2px_rgba(0,0,0,0.18)]',
  resourceQty:
    'text-[0.95rem] font-bold tabular-nums text-[#2B160A] [font-family:Merriweather,Georgia,serif] [text-shadow:0_1px_0_rgba(255,252,245,0.1),0_1px_2px_rgba(0,0,0,0.18)]',
  contributionRate:
    'text-[0.75rem] font-normal text-[#4A2A10] [font-family:Cormorant_Garamond,Georgia,serif] [text-shadow:0_1px_1px_rgba(0,0,0,0.12)]',
} as const

/** Diplomacy + Messages: same font size/weight/color system as Manage → Overview. */
export const ALLIANCE_MANAGE_TAB_TEXT = {
  body: `text-left ${ALLIANCE_MANAGE_BODY_CORE}`,
  bodyCenter: `text-center ${ALLIANCE_MANAGE_BODY_CORE}`,
  bodySemibold:
    'text-left text-[0.72rem] font-semibold leading-relaxed text-[#3A1C0B] sm:text-xs [font-family:Cormorant_Garamond,EB_Garamond,Georgia,serif] [text-shadow:0_1px_2px_rgba(0,0,0,0.12)]',
  bodySemiboldCenter:
    'text-center text-[0.72rem] font-semibold leading-relaxed text-[#3A1C0B] sm:text-xs [font-family:Cormorant_Garamond,EB_Garamond,Georgia,serif] [text-shadow:0_1px_2px_rgba(0,0,0,0.12)]',
  muted: ALLIANCE_OVERVIEW_TEXT.governanceSub,
  /** Left-aligned muted line (governanceSub is centered on Overview). */
  secondary:
    'text-left text-[0.64rem] font-normal leading-snug text-[#5a4030] sm:text-xs [font-family:Cormorant_Garamond,Georgia,serif] [text-shadow:0_1px_1px_rgba(0,0,0,0.15)]',
  hint: ALLIANCE_OVERVIEW_TEXT.bannerHint,
  label: ALLIANCE_OVERVIEW_TEXT.statLabel,
  value: ALLIANCE_OVERVIEW_TEXT.statValue,
  /** Tabular numbers, overview stat color (countdowns, points in rows). */
  numeric: ALLIANCE_OVERVIEW_TEXT.governanceScoreInline,
  tableHead: ALLIANCE_OVERVIEW_TEXT.tableHead,
  tableRow: ALLIANCE_OVERVIEW_TEXT.tableRow,
  tableMuted: ALLIANCE_OVERVIEW_TEXT.tableMutedCell,
  tableCell:
    'align-middle text-[0.65rem] font-normal text-[#2B160A] sm:text-xs [font-family:Merriweather,Georgia,serif]',
  tableCellMuted:
    'align-middle text-[0.65rem] font-normal text-[#4A3318] sm:text-xs [font-family:Merriweather,Georgia,serif]',
  tabBarInactive:
    'text-center text-[0.72rem] font-normal leading-relaxed text-[#5a4030] sm:text-xs [font-family:Cormorant_Garamond,EB_Garamond,Georgia,serif] [text-shadow:0_1px_2px_rgba(0,0,0,0.12)]',
  tabBarActive:
    'text-center text-[0.72rem] font-semibold leading-relaxed text-[#2B160A] sm:text-xs [font-family:Merriweather,Cinzel,Georgia,serif] [text-shadow:0_-0.5px_0_rgba(255,248,238,0.05),0_1px_0_rgba(0,0,0,0.22),0_1px_2px_rgba(0,0,0,0.12)]',
  empty: ALLIANCE_OVERVIEW_TEXT.emptyState,
} as const

/** Tasks tab — text colors aligned with Manage → Overview. */
export const ALLIANCE_TASKS_TEXT = {
  heroTitle: ALLIANCE_PANEL_GOLD_TITLE + ' text-center text-base tracking-[0.14em] sm:text-left sm:text-lg',
  columnTitle: ALLIANCE_PANEL_GOLD_TITLE + ' text-center text-sm tracking-[0.12em] sm:text-left sm:text-base',
  categoryHeading: ALLIANCE_PANEL_GOLD_TITLE + ' text-left text-[0.65rem] tracking-[0.08em]',
  periodBandLabel: ALLIANCE_PANEL_GOLD_TITLE + ' text-left text-[0.56rem] tracking-[0.06em] sm:text-[0.58rem]',
  heroBody:
    'mt-1.5 text-center text-xs font-light italic leading-relaxed text-[#4A2B12] [font-family:Cormorant_Garamond,EB_Garamond,Georgia,serif] [text-shadow:0_1px_3px_rgba(0,0,0,0.18)] sm:text-left sm:text-sm',
  badgeLabel:
    'font-alliance-panel text-[0.62rem] font-semibold uppercase tracking-wide text-[#4A2A10] [text-shadow:0_1px_1px_rgba(0,0,0,0.15)]',
  body: ALLIANCE_OVERVIEW_TEXT.announcementBody,
  bodyMuted: ALLIANCE_OVERVIEW_TEXT.governanceSub,
  hint: ALLIANCE_OVERVIEW_TEXT.bannerHint,
  label: ALLIANCE_OVERVIEW_TEXT.statLabel,
  valueStrong: ALLIANCE_OVERVIEW_TEXT.statValue,
  accentWarm: 'font-medium text-[#5A3315] [font-family:Cinzel,Georgia,serif]',
  tableHeadRow: `${ALLIANCE_OVERVIEW_TEXT.tableHead} bg-[rgba(90,62,40,0.12)]`,
  tableCell:
    'text-[0.75rem] font-medium text-[#2B160A] [font-family:Merriweather,Georgia,serif] [text-shadow:0_1px_0_rgba(255,252,245,0.08),0_1px_2px_rgba(0,0,0,0.12)]',
  tableCellNumeric: 'tabular-nums font-semibold text-[#2B160A] [font-family:Merriweather,Georgia,serif]',
  emptyCell:
    'text-center font-thin text-[0.72rem] italic leading-relaxed text-[#5a4030] [font-family:Cormorant_Garamond,Georgia,serif]',
  finalizeBoxLabel: 'min-w-0 text-[0.65rem] text-[#4A2A10] [font-family:Cinzel,Georgia,serif]',
  formLabel: 'text-[0.6rem] text-[#4A2A10] [font-family:Cinzel,Georgia,serif]',
  subCaption:
    'min-w-0 max-w-[15rem] text-[0.52rem] font-thin leading-snug text-[#5a4030] sm:text-[0.55rem] [font-family:Cormorant_Garamond,Georgia,serif]',
  dateRowPrimary: 'min-w-0 font-thin text-[#3A1C0B] [font-family:Cormorant_Garamond,Georgia,serif]',
  dateRowAccent: 'font-medium text-[#5A3315] [font-family:Cinzel,Georgia,serif]',
  chipHint: 'mt-0.5 block text-[0.55rem] font-thin text-[#5a4030] [font-family:Cormorant_Garamond,Georgia,serif]',
  addRowBtn:
    'inline-flex items-center justify-center rounded border border-[rgba(158,118,78,0.45)] bg-black/20 px-0.5 py-0.5 font-semibold leading-none text-[#5A3315] hover:bg-black/35 [font-family:Cinzel,Georgia,serif]',
} as const

export const MIN_LEVEL_JOIN = 5
export const MIN_LEVEL_CREATE = 10
export const ERA_SETTLER = 2

/** Player diplomacy tiers that allow showing/sending alliance invites (not `spirit`). Sync with backend `ALLIANCE_INVITE_DIPLOMACY_LEVELS`. */
export const ALLIANCE_INVITE_DIPLOMACY_LEVELS = ['ceasefire', 'alliance', 'marriage'] as const
export type AllianceInviteDiplomacyLevel = (typeof ALLIANCE_INVITE_DIPLOMACY_LEVELS)[number]

export function isAllianceInviteDiplomacyLevel(level: string | null | undefined): level is AllianceInviteDiplomacyLevel {
  return !!level && (ALLIANCE_INVITE_DIPLOMACY_LEVELS as readonly string[]).includes(level)
}

/** Keep only users whose diplomacy with the leader is ceasefire or stronger (frontend guard). */
export function filterInvitableUsersForAllianceInvite<T extends { diplomacyLevel?: string | null }>(users: T[]): T[] {
  return users.filter((u) => !u.diplomacyLevel || isAllianceInviteDiplomacyLevel(u.diplomacyLevel))
}

/** Max pending outgoing invites by leader level — must match backend `getAllianceOutgoingInviteLimit`. */
export function getAllianceOutgoingInviteLimit(leaderLevel: number): number {
  const L = Number(leaderLevel) || 0
  if (L < 10) return 0
  return 4 + Math.floor((L - 10) / 5)
}

/** "1.23M" / "4.5K" / "820" — Alliance Power, Contribution, and similar large stat columns. */
export function formatCompactNumber(n: number): string {
  const v = Number(n) || 0
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)}K`
  return Math.floor(v).toLocaleString()
}

/** "5m ago" / "3h ago" / "2d ago" — Last Online columns. */
export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return ''
  const diffMs = Date.now() - then
  const min = Math.floor(diffMs / 60000)
  if (min < 1) return 'just now'
  if (min < 60) return `${min}m ago`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`
  const day = Math.floor(hr / 24)
  return `${day}d ago`
}

/** Alliance member limit based on leader's user level - must match backend logic */
export function getAllianceMaxMembers(leaderLevel: number): number {
  const level = Number(leaderLevel) || 0
  if (level < 15) {
    if (level < 10) return 0
    return 5 + Math.min(5, level - 5)
  }
  if (level <= 19) return level - 5
  if (level <= 34) return level
  if (level <= 49) return level + 5
  if (level <= 59) return 80 + (level - 50) * 2
  return 100 + (level - 60)
}
